import { useVisitorData } from "@fingerprintjs/fingerprintjs-pro-react";
import * as Sentry from "@sentry/react";

/**
 * Custom hook that provides device identification functionality
 * This abstracts away the specific implementation (Fingerprint Pro)
 */
export function useDeviceIdentification() {
  // Use the Fingerprint Pro hook with extended data and lazy loading
  const { getData, isLoading, error } = useVisitorData(
    { extended: true },
    { immediate: false }
  );

  // Helper to generate a fallback ID string
  const generateFallbackId = () => {
    return `fallback_${Date.now()}_${Math.floor(Math.random() * 1000000)}`;
  };

  // Return a consistent interface that wraps the current implementation
  return {
    getVisitorId: async () => {
      try {
        const result = await getData();
        if (result && result.visitorId) {
          // Store the ID for later use
          localStorage.setItem("fingerId", result.visitorId);
          return result.visitorId;
        }
        Sentry.captureException(
          new Error("FingerprintJS: No valid visitorId, using fallback"),
          {
            extra: {
              result,
              reason: "No visitorId in result"
            }
          }
        );
        // Return a generated fallback string instead of null
        const fallbackId = generateFallbackId();
        localStorage.setItem("fingerId", fallbackId);
        return fallbackId;
      } catch (err) {
        // Return a generated fallback string instead of null
        const fallbackId = generateFallbackId();
        localStorage.setItem("fingerId", fallbackId);
        return fallbackId;
      }
    },
    isLoading,
    error,
    getStoredId: () => localStorage.getItem("fingerId")
  };
}
